import { render } from "./sdgd.vue?vue&type=template&id=c3a63f06&scoped=true&ts=true"
import script from "./sdgd.vue?vue&type=script&lang=ts"
export * from "./sdgd.vue?vue&type=script&lang=ts"

import "./sdgd.vue?vue&type=style&index=0&id=c3a63f06&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a63f06"]])

export default __exports__